import EmberObject from '@ember/object';

export function computeFromComponentValues(c1, r1, r3, r4) {
  var gain = 1 + r4 / r3;
  var fp = 1 / (Math.PI * 2 * r1 * c1);
  var q = 0;
  var result = EmberObject.create({ stageQ: q, stageFp: fp, gain: gain });
  return result;
}

export function execute(circuit) {
  var c1 = circuit.c1.value;
  var r1 = circuit.r1.value;
  var r3 = circuit.r3.value;
  var r4 = circuit.r4.value;
  return computeFromComponentValues(c1, r1, r3, r4);
}
